<template>
    <gs-named-modal class="gs-refresh-controls" name="add-commission-advance-modal" :title="$t('frontend_groovesell_add_commision_advance')"
        bg-type="regular">
        <div v-if="selectedAffiliate" class="flex">
            <div class="flex flex-col w-full px-4">
                <div class="mt-2">
                    <div class="w-full flex flex-row mb-6">
                        <label class="w-1/3 mt-1 font-semibold text-grey-700">{{
                            $t('frontend_affiliate_index_amount')
                        }}</label>
                        <div class="w-2/3">
                            <gd-currency-input v-model="commissionAdvance.amount" currency-code="USD" />
                        </div>
                    </div>
                    <div class="w-full flex flex-row mb-6">
                        <label class="w-1/3 mt-1 font-semibold text-grey-700">{{
                            $t('frontend_affiliate_index_transaction')
                        }}</label>
                        <text-input v-model="commissionAdvance.transactionId"
                            :validator="validation.commissionAdvance.transactionId"
                            :attribute="$t('frontend_affiliate_index_transaction_id')" class="w-2/3"
                            value="commissionAdvance.transactionId"
                            :placeholder="$t('frontend_affiliate_index_transaction_id')" />
                    </div>
                    <div class="w-full flex flex-row mb-6">
                        <label class="w-1/3 mt-1 font-semibold text-grey-700">{{
                            $t('frontend_affiliate_index_comment')
                        }}</label>
                        <text-input v-model="commissionAdvance.comment" :validator="validation.commissionAdvance.comment"
                            :attribute="$t('frontend_affiliate_index_comment')" class="w-2/3"
                            value="commissionAdvance.comment" :placeholder="$t('frontend_affiliate_index_comment')" />
                    </div>
                    <div class="flex flex-row w-full mb-6 justify-end">
                        <gs-button size="md" class="mb-4" variant="primary" :disabled="isProcessingAdvance" :aria-busy="isProcessingAdvance" @click="addCommissionAdvance()">
                            <span v-if="isProcessingAdvance" role="status"><span aria-hidden="true" class="inline-block animate-spin mr-2" style="width: 12px; height: 12px; border: 2px solid currentColor; border-right-color: transparent; border-radius: 50%;"></span>Recording…</span>
                            <span v-else>{{ $t('frontend_affiliate_index_add_commision_advance') }}</span>
                        </gs-button>
                    </div>
                </div>
            </div>
        </div>
    </gs-named-modal>
</template>
<style scoped>
.animate-spin { animation: affiliate-advance-spin .7s linear infinite; }
@keyframes affiliate-advance-spin { to { transform: rotate(360deg); } }
@media(prefers-reduced-motion: reduce) { .animate-spin { animation: none; } }
@media (max-width: 640px) {
    .flex.flex-row {
        min-width: 0;
        flex-wrap: wrap;
    }

    .flex.flex-row > [class~="w-1/3"],
    .flex.flex-row > [class~="w-2/3"] {
        width: 100%;
    }
}
</style>
<script>
export default {
    props: {
        isProcessingAdvance: {
            type: Boolean,
            default: false
        },
        selectedAffiliate: {
            type: Object,
            default: null
        },
        addCommissionAdvance: {
            type: Function,
            default: null
        },
        validation: {
            required: true,
        }
    },
    data() {
        return {
            commissionAdvance: {
                amount: 0,
                transactionId: '',
                comment: ''
            }
        }
    },
    watch: {
        commissionAdvance: {
            handler: function (val, oldVal) {
                this.validation.commissionAdvance.$touch();
                this.$emit('update-commission-advance', val);
            },
            deep: true

        }
    },
}
</script>
